/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ImportRelationBehaviour {
    Ignore = '0',
    Update = 1,
    Patch = 2,
}
